module.exports = __webpack_public_path__ + "static/media/Sad.b337ffb8.png";